import { render, staticRenderFns } from "./responsibilities.vue?vue&type=template&id=60158bfe&scoped=true&"
import script from "./responsibilities.vue?vue&type=script&lang=js&"
export * from "./responsibilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60158bfe",
  null
  
)

export default component.exports